import { BlockContainer } from '@components';
import { Box, Grid, Skeleton, Stack } from '@mui/material';

export const ProductRequestDetailsSkeleton = () => {
  return (
    <BlockContainer>
      {/* Dealer Name */}
      <Skeleton variant='text' width={300} height={80} />
      <Skeleton variant='rectangular' width='100%' height={2} />

      {/* Request Details Title */}
      <Skeleton variant='text' width={250} height={60} />

      <Grid container spacing={4}>
        <Grid item xs={12} md={6}>
          {/* Request Details */}
          <Stack direction='row' mb={2} mt={4} spacing={8}>
            <Skeleton variant='text' width={200} height={20} />
            <Skeleton variant='text' width={150} height={20} />
            <Skeleton variant='text' width={150} height={20} />
          </Stack>

          {/* Product Order Element */}
          <Box display='flex' gap={2} p={4} bgcolor='white' mb={4}>
            <Skeleton variant='rectangular' width={100} height={100} />
            <Skeleton variant='text' width={200} height={20} />
            <Skeleton variant='text' width={100} height={20} />
          </Box>

          {/* Product Request Info Messages */}
          <Skeleton variant='text' width='100%' height={100} />
        </Grid>

        <Grid item xs={12} md={6}>
          {/* Attachments */}
          <Box width='100%' mt={4}>
            <Skeleton variant='text' width={250} height={30} />
          </Box>

          <Skeleton variant='text' width='100%' height={100} />
        </Grid>
      </Grid>
    </BlockContainer>
  );
};
